import React, { useEffect } from 'react'
import { actionCreators } from '@/store/Forms'
import context from '@/context'
import LoadingIndicator from '@/components/LoadingIndicator'
import { FormContext } from './formContext'
import { NotFound404 } from '@/components/404'
import { changeRequestIdSelector, formPropsSelector } from '@/components/changeRequests/selectors'
import pascalCase from '@/utils/pascalCase'
import { modes } from './propertyRenderer'
import { useReduxState } from '@/hooks/reduxState'
import { useDispatch } from '@/hooks/dispatch'

let FormLoaderInternal = (props) => {
  function mapStateToProps (state) {
    const formProps = formPropsSelector(state, props)
    const isTempForm = !!props.uid
    const changeRequestId = changeRequestIdSelector(state, props)
    const mappedProps = {
      ...formProps,
      changeRequestId,
      isTempForm,
      ...props
    }
    if (props.mode === modes.edit && props.value && props.value.isDeleted) {
      mappedProps.mode = modes.view
    }
    return mappedProps
  }

  const [dataLoaded, dataLoadFailed, removeData] = useDispatch([
    actionCreators.dataLoaded,
    actionCreators.dataLoadFailed,
    actionCreators.removeData
  ])

  const mappedProps = useReduxState(mapStateToProps)
  const {
    uid,
    parentUid,
    id,
    mode,
    targetId,
    targetInstitutionId,
    scope,
    isChangeItemId,
    changeRequestId,
    changeItemId,
    target,
    render, loader, isLoaded, isTempForm, unavailable } = mappedProps

  // loadData
  useEffect(() => {
    const loadData = !isTempForm && isChangeItemId
      ? context.api.changeRequestService.getChangeItem(id)
        .then(x => {
          if (typeof x.modifiedData === 'string') x.modifiedData = JSON.parse(x.modifiedData)
          if (typeof x.originalData === 'string') x.originalData = JSON.parse(x.originalData)
          return x
        })
      : loader(id).then(data => {
        let value = data
        let originalValue = data
        let approvedValue = data
        if (data.__dialogLoader) {
          value = data.value
          originalValue = data.originalValue
          approvedValue = data.approvedValue
        }
        return {
          parentUid,
          id: changeItemId,
          target: target,
          targetId: id,
          scope: scope,
          originalData: originalValue,
          modifiedData: value,
          approvedValues: approvedValue,
          permissions: (originalValue && originalValue.permissions) || 0
        }
      })

    loadData
      .then(data => dataLoaded(uid, data))
      .catch(err => dataLoadFailed(uid, err))

    return () => { // cleanup
      if (uid && uid.startsWith('#')) { // dispose temp changes
        removeData(uid)
      }
    }
  }, [id, mode, scope, isChangeItemId, changeRequestId, uid, isTempForm, parentUid, changeItemId, target, dataLoaded, dataLoadFailed, removeData, loader])

  function getContextProps () {
    return {
      uid,
      parentUid,
      targetId,
      targetInstitutionId,
      target,
      scope,
      mode,
      changeRequestId,
      changeItemId,
      isChangeItemId
    }
  }

  if (unavailable) {
    return <NotFound404 />
  }
  if (isLoaded) {
    return <FormContext.Provider value={getContextProps()}>
      {typeof render === 'function' ? render({ ...mappedProps, dataLoaded, dataLoadFailed, removeData }) : props.children}
    </FormContext.Provider>
  }
  return <LoadingIndicator />
}

function parseUrlParams (match, props) {
  const params = {}
  if (match && match.params) {
    const scope = match.params.scope || props.scope
    if (scope) {
      params.id = Number(match.params.id)
      params.isChangeItemId = !!match.params.isChangeItemId
      params.scope = pascalCase(scope)
      params.uid = `/${scope}/${params.isChangeItemId ? '~' : ''}${params.id}`
    } else { // external
      params.uid = `/${props.scope}/${props.isChangeItemId ? '~' : ''}${props.id}`
    }
  }
  return params
}

const FormLoader = ({ match, ...props }) =>
  <FormLoaderInternal
    {...parseUrlParams(match, props)}
    {...props}
    isTempForm={!!props.uid}
  />
export {
  FormLoader
}



// WEBPACK FOOTER //
// ./src/components/changeRequests/formLoader.js